const navConfig = [
  {
    name: '项目管理',
    path: '/customer',
    icon: 'az-app-folder'
  },
  {
    name: '企业管理',
    path: '/company',
    icon: 'az-app-folder'
  },
  {
    name: '审批管理',
    path: '/approval',
    icon: 'az-app-folder',
    children: [
      {
        name: '审批记录',
        path: '/approval/instance'
      },
      {
        name: '审批流程',
        path: '/approval/project'
      }
    ]
    // sign: 'approval'
  },
  {
    name: '机构管理',
    path: '/org',
    icon: 'az-app-folder',
    sign: 'orgManage'
  },
  {
    name: '审批管理',
    path: '/auth-code',
    icon: 'az-app-order',
    sign: 'authCode'
  },
  {
    name: '个人信息',
    path: '/version',
    icon: 'az-app-user',
    sign: 'version'
  }
];

export default navConfig;